export const commentsMock = 
    [
        {
          "id": 0,
          "authorName": "Oneal",
          "publicationDate": "2012-07-24T04:04:11.921Z",
          "content": "Excepteur cillum Lorem amet cillum culpa ut."
        },
        {
          "id": 1,
          "authorName": "Beth",
          "publicationDate": "2004-01-25T12:03:39.699Z",
          "content": "Proident commodo do veniam quis commodo exercitation ut tempor incididunt est."
        },
        {
          "id": 2,
          "authorName": "Silva",
          "publicationDate": "1985-05-18T12:01:50.706Z",
          "content": "Elit aliqua culpa adipisicing reprehenderit in commodo reprehenderit labore anim elit labore."
        },
        {
          "id": 3,
          "authorName": "Acosta",
          "publicationDate": "2019-08-02T22:48:27.024Z",
          "content": "Officia amet sint quis incididunt id tempor ea commodo et."
        },
        {
          "id": 4,
          "authorName": "Allyson",
          "publicationDate": "1985-10-01T05:53:02.579Z",
          "content": "Veniam in consequat ea cupidatat exercitation do est duis voluptate aliqua enim do sit ullamco."
        },
        {
          "id": 5,
          "authorName": "Jenna",
          "publicationDate": "1976-09-28T14:02:33.391Z",
          "content": "Sit officia in deserunt velit sunt irure commodo officia excepteur excepteur nulla dolore."
        },
        {
          "id": 6,
          "authorName": "Lou",
          "publicationDate": "2020-09-05T10:02:19.070Z",
          "content": "Est dolore incididunt nostrud veniam sint enim ullamco."
        },
        {
          "id": 7,
          "authorName": "Rosemary",
          "publicationDate": "2022-03-23T23:21:31.909Z",
          "content": "Esse sit aliqua dolor pariatur adipisicing fugiat sit nulla."
        },
        {
          "id": 8,
          "authorName": "Malone",
          "publicationDate": "2008-08-15T02:02:37.480Z",
          "content": "Dolor esse duis Lorem consequat dolore."
        },
        {
          "id": 9,
          "authorName": "Rosa",
          "publicationDate": "2012-05-01T15:20:52.111Z",
          "content": "Est ut non cupidatat in magna nulla proident sint."
        },
        {
          "id": 10,
          "authorName": "Deanne",
          "publicationDate": "2017-06-03T06:56:08.518Z",
          "content": "Veniam ullamco enim fugiat id eu sit aute."
        },
        {
          "id": 11,
          "authorName": "Robin",
          "publicationDate": "1996-08-30T11:53:23.746Z",
          "content": "Voluptate eiusmod anim incididunt labore ex ullamco officia officia amet fugiat mollit culpa labore."
        },
        {
          "id": 12,
          "authorName": "Ila",
          "publicationDate": "1984-10-19T08:20:43.907Z",
          "content": "Esse enim cupidatat ipsum reprehenderit minim Lorem minim tempor sint culpa duis veniam ullamco fugiat."
        },
        {
          "id": 13,
          "authorName": "Rivas",
          "publicationDate": "1990-07-25T08:43:31.027Z",
          "content": "Ipsum magna do reprehenderit aliqua cupidatat irure consequat laborum excepteur est id amet reprehenderit excepteur."
        },
        {
          "id": 14,
          "authorName": "Geneva",
          "publicationDate": "1998-12-13T06:06:56.565Z",
          "content": "Ipsum magna ullamco nulla consequat dolor veniam nostrud labore qui dolore pariatur."
        },
        {
          "id": 15,
          "authorName": "Selena",
          "publicationDate": "2003-05-12T21:51:22.674Z",
          "content": "Officia nostrud pariatur dolor nisi esse eiusmod cupidatat ad nulla."
        },
        {
          "id": 16,
          "authorName": "Sykes",
          "publicationDate": "1989-08-03T09:34:02.720Z",
          "content": "Nulla nostrud eu exercitation dolor fugiat enim duis et exercitation dolore aute occaecat pariatur."
        },
        {
          "id": 17,
          "authorName": "Bentley",
          "publicationDate": "1993-04-03T12:47:01.354Z",
          "content": "Ullamco ad mollit laborum duis ad minim voluptate occaecat occaecat."
        },
        {
          "id": 18,
          "authorName": "Pearl",
          "publicationDate": "1981-03-09T02:54:06.529Z",
          "content": "Commodo amet do velit anim laboris magna labore anim ad proident."
        },
        {
          "id": 19,
          "authorName": "Strong",
          "publicationDate": "1982-02-13T12:36:41.765Z",
          "content": "Tempor adipisicing veniam est mollit cillum adipisicing aute voluptate aliqua laboris."
        }
      ]
